var _PixTag;
import Component from '@glimmer/component';
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class PixTag extends Component {
  get classes() {
    const {
      color
    } = this.args;
    const classes = [];
    if (color) classes.push(`pix-tag--${color}`);
    return classes.join(' ');
  }
}
_PixTag = PixTag;
setComponentTemplate(precompileTemplate("\n    <div class=\"pix-tag {{this.classes}}\" ...attributes>\n      {{yield}}\n    </div>\n  ", {
  strictMode: true
}), _PixTag);